/** -- external -- */
import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";

import ConditionalWrapper from "Utils/ConditionalWrapper";
import { Tooltip, useKeyboardShortcutsContext } from "@toddle-edu/ds-web";

/** -- relative -- */
import classes from "./ModuleCard.scss";
import ShortcutChip from "../ShortcutChip";
import { getIsGlobalSearchJumpToRevampEnabled } from "GlobalHeader/modules/Utils";

const courseDetailsTooltipOverlayStyle = { pointerEvents: "none" };

const ModuleNameWithTooltip = ({ title, subTitle }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const titleRef = useRef();

  const checkAndSetTruncation = () => {
    const label = titleRef.current;
    if (label) {
      setShowTooltip(label.scrollHeight > label.clientHeight);
    }
  };

  useEffect(() => {
    checkAndSetTruncation();
    window.addEventListener("resize", checkAndSetTruncation);
    return () => {
      window.removeEventListener("resize", checkAndSetTruncation);
    };
  }, [title]);

  const labelClasses = classNames(classes.label, "text-body-2");
  const subLabelClasses = classNames(classes.subLabel, "text-body-s");

  return (
    <ConditionalWrapper
      type="wrapperAsElement"
      condition={showTooltip}
      wrapper={
        <Tooltip
          tooltip={title}
          placement="bottom"
          overlayStyle={courseDetailsTooltipOverlayStyle}
        />
      }
    >
      <div className={classes.moduleDetailsContainer}>
        <div className={labelClasses} ref={titleRef}>
          {title}
        </div>
        <div className={subLabelClasses}>{subTitle}</div>
      </div>
    </ConditionalWrapper>
  );
};

const ModuleCard = props => {
  const {
    icon,
    iconStyle,
    onCardClick,
    label,
    shortcutKey,
    shiftKey,
    columnIndex,
    testId,
    subLabel,
  } = props;

  const { areShortcutsEnabled } = useKeyboardShortcutsContext();

  const isGlobalSearchJumpToRevampEnabled = getIsGlobalSearchJumpToRevampEnabled();
  const containerClasses = isGlobalSearchJumpToRevampEnabled
    ? classes.containerV2
    : classes.container;

  return (
    <div
      className={containerClasses}
      onClick={onCardClick}
      data-elm={`jump-to-col-${columnIndex}`}
      tabIndex="-1"
      data-test-id={testId}
    >
      <div className={classes.leftContainer}>
        <div className={classes.iconContainer} style={iconStyle}>
          {icon}
        </div>
        <ModuleNameWithTooltip title={label} subTitle={subLabel} />
      </div>
      {shortcutKey && areShortcutsEnabled ? (
        <ShortcutChip shortcutKey={shortcutKey} shiftKey={shiftKey} />
      ) : null}
    </div>
  );
};

export default ModuleCard;
